// Файл app_root.js

import {
    lazy,
    Suspense,
    useEffect,
    useState,
} from 'react';
import { Provider } from 'react-redux';

import BrowserLock from './components/BrowserLock';
import ConsentPanel from './components/ConsentPanel';
import { ToastProvider } from './components/Toast';
import Page_authorization from './page_authorization';
import store from './redux/store';
import LoadingIndicator from './shared_code/loading';
import StatePersistor from './utils/StatePersistor';
import { storage } from './utils/storage';
import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
    useLocation,
} from './utils/simple_router';



const App_Lk = lazy(() => import('./pages_LK/app_Lk'));
const App_bux = lazy(() => import('./pages/app_bux'));
const App_developer = lazy(() => import('./pages_dev/app_developer'));
const App_office = lazy(() => import('./pages_office/app_office'));

const AppReadyMarker = ({ on_ready }) => {
    useEffect(() => {
        if (on_ready) {
            on_ready();
        } else {
            window.__POTALE_APP_READY__ = true;
        }

        const url = new URL(window.location.href);

        if (url.searchParams.has('__potale_recover')) {
            url.searchParams.delete('__potale_recover');
            window.history.replaceState(
                window.history.state,
                '',
                `${url.pathname}${url.search}${url.hash}`,
            );
        }
    }, [on_ready]);

    return null;
};

const Global_cookie_banner = () => {
    const location = useLocation();
    const path = location.pathname || '/';
    const is_auth_zone = (
        path === '/'
        || path.startsWith('/page_load_mobile_version')
    );

    if (is_auth_zone) {
        return null;
    }

    return <ConsentPanel />;
};

const App = ({ mobile_route, fallback_route }) => {
    const [bootReady, setBootReady] = useState(false);
    const [startPath, setStartPath] = useState('/');

    useEffect(() => {
        const lastVisitedPage = storage.get_item('lastVisitedPage');
        const allowedPaths = [
            '/LK',
            '/bux',
            '/developer',
            '/office',
        ];

        setStartPath(
            allowedPaths.includes(lastVisitedPage)
                ? lastVisitedPage
                : '/'
        );
        setBootReady(true);
    }, []);

    if (!bootReady) {
        return (
            <div>
                <LoadingIndicator />
            </div>
        );
    }

    return (
        <Router>
            <Suspense
                fallback={(
                    <div>
                        <LoadingIndicator />
                    </div>
                )}
            >
                <Routes>
                    <Route
                        path="/"
                        element={(
                            startPath !== '/'
                                ? <Navigate to={startPath} replace />
                                : <Page_authorization />
                        )}
                    />
                    {mobile_route}
                    <Route
                        path="/bux"
                        element={<App_bux />}
                    />
                    <Route
                        path="/LK"
                        element={<App_Lk />}
                    />
                    <Route
                        path="/developer"
                        element={<App_developer />}
                    />
                    <Route
                        path="/office"
                        element={<App_office />}
                    />
                    {fallback_route}
                </Routes>
            </Suspense>
            <Global_cookie_banner />
        </Router>
    );
};

const RootComponent = ({
    ErrorBoundaryComponent,
    mobile_route,
    fallback_route,
    on_ready,
}) => (
    <ErrorBoundaryComponent>
        <Provider store={store}>
            <StatePersistor />
            <ToastProvider>
                <AppReadyMarker on_ready={on_ready} />
                <App
                    mobile_route={mobile_route}
                    fallback_route={fallback_route}
                />
                <BrowserLock />
            </ToastProvider>
        </Provider>
    </ErrorBoundaryComponent>
);


export default RootComponent;
